<template>
    <div class="text-xs">
        <base-svg
            name="icon-add-circle"
            class="absolute top-0 left-0 w-6 h-6"
            :class="{
                'fill-primary-blue fill-secondary-blue-lighter': _.isNull(entry.persona)
            }"
        />

        <pre>{{ entry }}</pre>
    </div>
</template>

<script>
    export default {
        props: {
            entry: {
                type: Object,
                required: true
            }
        }
    }
</script>
